// src/components/WeightForm.js
import React, { useState } from "react";
import { auth, db } from "../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

export default function WeightForm({ onSave }) {
  const [weight, setWeight] = useState("");
  const [unit, setUnit] = useState("kg");
  const [dateTime, setDateTime] = useState("");
  const [note, setNote] = useState("");

  const handleSave = async () => {
    if (!weight) return;
    const user = auth.currentUser;
    if (!user) return;

    const weightKg = unit === "lb" ? parseFloat(weight) * 0.453592 : parseFloat(weight);
    const finalDate = dateTime ? new Date(dateTime) : new Date();

    try {
      await addDoc(collection(db, "users", user.uid, "weights"), {
        weight: weightKg,
        unit,
        note,
        createdAt: Timestamp.fromDate(finalDate),
      });

      setWeight("");
      setNote("");
      setDateTime("");
      if (onSave) onSave();
    } catch (error) {
      console.error("Error saving weight:", error);
    }
  };

  return (
    <div className="form-container">
      <input
        type="number"
        value={weight}
        placeholder="e.g., 72.5"
        onChange={(e) => setWeight(e.target.value)}
      />
      <select value={unit} onChange={(e) => setUnit(e.target.value)}>
        <option value="kg">kg</option>
        <option value="lb">lb</option>
      </select>
      <input
        type="datetime-local"
        value={dateTime}
        onChange={(e) => setDateTime(e.target.value)}
      />
      <input
        type="text"
        placeholder="Optional note"
        value={note}
        onChange={(e) => setNote(e.target.value)}
      />
      <button onClick={handleSave} className="save-btn">Save Weight</button>
    </div>
  );
}
